import React from 'react';
import { Form, Button, Input, Select } from 'antd';
import { AddSubjectWrapper } from './subject.style';

import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useGrade } from 'features/routine/hooks/useGrade';
import { useSubject } from 'features/result/hooks/useSubject';

export const AddSubjectDetails = (props: any) => {
  const { onSaveSubject } = useSubject();
  const [form] = Form.useForm();
  const { onVisibleChange, onSetReloadSubject } = props;
  const grade = useSelector((state: RootState) => state.grade);
  const { fetchGrade } = useGrade();
  const handleSubmit = () => {
    onSaveSubject({ ...form.getFieldsValue() }, form, onVisibleChange, onSetReloadSubject);
  };
  React.useEffect(() => {
    fetchGrade();
  }, []);
  return (
    <AddSubjectWrapper>
      <Form form={form} size="large" layout="vertical">
        <Form.Item name="title" label="Title">
          <Input />
        </Form.Item>
        <Form.Item name="code" label="Course Code">
          <Input placeholder="ENG101" />
        </Form.Item>
        <Form.Item name="gradeId" label="Grade">
          <Select defaultValue=" Select Grade">
            {grade.data.map((item, index) => (
              <Select.Option key={index} value={item.id}>
                {item.id}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="full_mark" label="Full Mark">
          <Input type="number" max={100} min={0} placeholder="100" />
        </Form.Item>
        <Form.Item name="pass_mark" label="Pass Mark">
          <Input type="number" max={100} min={0} placeholder="20" />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input.TextArea />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" onClick={handleSubmit}>
            SAVE
          </Button>
        </Form.Item>
      </Form>
    </AddSubjectWrapper>
  );
};

export default AddSubjectDetails;
